@if (user) {
  @if (workspaces) {
    <header #topBar id="nav-bar" class="topBar">
      @if (routerPath.startsWith('workspace.point') || routerPath === 'settings.user') {
        <a class="logoBlock showLogoTrue" [routerLink]="['/site', user.activeWorkspaceId]">
          <i class="fas fa-chevron-left menu-control" aria-hidden="true"></i>
        </a>
      }
      <div
        class="topBar__site"
        [class.topBar__site--mobile]="showMobileSiteName"
        data-m-target="Site name field"
      >
        @if (routerPath === '/settings/user') {
          <h4 class="topBar__account-name topBar__settings-title">
            {{ 'profile_settings' | ppTranslate }}
          </h4>
        }
        @if (routerPath === '/dashboard') {
          <h4 class="topBar__account-name">
            {{ 'dashboard' | ppTranslate }}
          </h4>
          <div
            ppTooltip
            id="dashboardSettingsDropdownButton"
            class="topBar__account-options"
            data-m-target="Dashboard settings button"
            ppTitle="Dashboard Settings"
            (click)="toggleDashboardSettingsDropdown('dashboardSettingsDropdownButton')"
          >
            <img
              [src]="EIconPath.INTERACTION_OPTIONS_DASHBOARD"
              class="topBar__account-options-icon"
            />
          </div>
        }
        @if (routerPath.startsWith('/fleet-management')) {
          <pp-top-bar-fleet-management-header></pp-top-bar-fleet-management-header>
        }
        @if (routerPath.startsWith('/settings/account')) {
          <h4 class="topBar__page-title topBar__accounts-title">
            {{ 'account_settings' | ppTranslate }}
          </h4>
        }
        @if (routerPath.startsWith('/reminders')) {
          <h4 class="topBar__page-title topBar__reminders-title">
            {{ 'calendar' | ppTranslate }}
          </h4>
        }
        @if (
          routerPath.startsWith('/settings/site') && !routerPath.startsWith('/settings/site/new')
        ) {
          <h4 class="topBar__page-title topBar__settings-title">
            {{ 'site_settings' | ppTranslate }}
          </h4>
        }
        @if (routerPath.startsWith('/settings/site/new')) {
          <h4 class="topBar__page-title topBar__settings-title">
            {{ 'new_site' | ppTranslate }}
          </h4>
        }
        @if (showAccountName) {
          <h4 class="topBar__account-name">
            {{ workspaces[paramId]?.accountName }}
            <span class="topBar__account-name--divider"> / </span>
          </h4>
        }
        @if (showSiteName) {
          <h4 class="topBar__site-name">
            {{ workspaces[paramId]?.siteName }}
          </h4>
        }
        @if (
          workspaces[paramId]?.share.shareOption === EUserRole.OWNER ||
          workspaces[paramId]?.share.shareOption === EUserRole.SITE_ADMIN ||
          workspaces[paramId]?.share.shareOption === EUserRole.ACCOUNT_ADMIN
        ) {
          <span
            ppTooltip
            id="siteSettingsDropdownButton"
            data-m-target="Site settings button"
            class="topBar__settings"
            ppTitle="Site Settings"
            (click)="toggleSiteSettingsDropdown('siteSettingsDropdownButton', paramId)"
          >
            <span class="topBar__cog-container" [class.topBar__cogContainer--active]="cogActive">
              <pp-icon
                [ppSrc]="EIconPath.ICON_COG_GREY"
                [ppClass]="cogActive ? 'top__setting-icon--active' : 'top__setting-icon'"
                class="topBar__page--svg"
                [ppDisplayContents]="true"
                (mousedown)="settingsClicked()"
                (mouseup)="settingsUnclicked()"
              ></pp-icon>
            </span>
          </span>
        }
        @if (routerPath.startsWith('/site/overview')) {
          <h4 class="topBar__account-name topBar__site-name--overview">
            {{ 'overview' | ppTranslate }}
          </h4>
        }
        @if (routerPath.startsWith('/site/timeline')) {
          <h4 class="topBar__account-name topBar__site-name--overview">
            {{ 'timeline' | ppTranslate }}
          </h4>
        }
      </div>
      @if (ppFleetLoaded && showFleetOptions) {
        <pp-top-bar-fleet-options class="topBar__fleet-options"></pp-top-bar-fleet-options>
      }
    </header>
  }
}
